import { init, createTracker, RegisterAnalyticsEvents } from '../client-js';
import directive from './directive';

export default {
  install: (Vue, { environment }) => {
    init({ environment });
    Vue.prototype.$track = (options) => createTracker(options)();
    Vue.prototype.$registerAnalyticsEvents = new RegisterAnalyticsEvents(Vue.prototype.$track);

    Vue.directive('analytics', directive);
  },
};
